import { Icon } from '@buggy/shared'
import { Radio, Tooltip } from 'antd'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useIntl } from '@/i18n/hooks/use-intl'
import { LayoutOption } from '@/types/layout-option'

export enum ViewMode {
  Grid = 'grid',
  List = 'list',
  Table = 'table',
}

interface ViewSwitcherProps {
  viewMode: ViewMode
  availableViewModes?: ViewMode[]
  onViewChange: (view: ViewMode) => void
}

const ViewSwitcher: FunctionComponent<ViewSwitcherProps> = ({
  viewMode,
  availableViewModes = [ViewMode.List, ViewMode.Grid],
  onViewChange,
}) => {
  const { formatMessage } = useIntl()

  const layoutOptions: LayoutOption[] = availableViewModes.map((viewMode) => {
    switch (viewMode) {
      case ViewMode.Grid:
        return {
          value: ViewMode.Grid,
          icon: 'grid',
          tooltipText: formatMessage({ id: 'search:view_grid_tooltip' }),
        }
      case ViewMode.List:
        return {
          value: ViewMode.List,
          icon: 'list',
          tooltipText: formatMessage({ id: 'search:view_list_tooltip' }),
        }
      case ViewMode.Table:
        return {
          value: ViewMode.Table,
          icon: 'table-outlined',
          tooltipText: formatMessage({ id: 'search:view_table_tooltip' }),
        }
    }
  })

  return (
    <RadioGroupWrapper>
      <Radio.Group
        value={viewMode}
        onChange={(e): void => onViewChange(e.target.value)}
      >
        {layoutOptions.map((item) => {
          return (
            <Tooltip key={item.value} placement='top' title={item.tooltipText}>
              <Radio.Button value={item.value}>
                <IconWrapper>
                  <Icon name={item.icon} />
                </IconWrapper>
              </Radio.Button>
            </Tooltip>
          )
        })}
      </Radio.Group>
    </RadioGroupWrapper>
  )
}

const RadioGroupWrapper = styled.div`
  width: fit-content;
  background: ${({ theme }): string => theme.colors.background.white};
  border-radius: 4px;
  padding: 2px;
  border: 1px solid ${({ theme }): string => theme.colors.border.border};

  .ant-radio-button-wrapper {
    border: none;
  }

  .ant-radio-button-wrapper::before {
    display: none;
  }

  .ant-radio-button-wrapper-checked {
    border-radius: 4px;
    background-color: ${({ theme }): string => theme.colors.brand.background};
  }
`

const IconWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export default ViewSwitcher
